import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import useApiClient, { apiRoutes } from "../../../../hooks/apiClient";
import EfisModal from "../../../../components/UI/EfisModal/EfisModal";

const useExcluirProrrogacaoModal = ({ onUpdate, setValues, setSolicitarProrrogacaoShow }) => {
  // Início Exclusão
  const {
    request: deleteItemRequest,
    isLoading: deleteItemIsLoading,
    data: deleteItemData,
    errors: deleteItemErrors,
  } = useApiClient();

  const [showExcluirConfirm, setShowExcluirConfirm] = useState({
    show: false,
    body: null,
    context: null,
  });

  useEffect(() => {
    if (!deleteItemData && !deleteItemErrors) return;

    if (deleteItemData) {
      setValues((prevValues) => ({
        ...prevValues,
        txProrrogacao: "",
        txJustificativa: "",
      }));

      setSolicitarProrrogacaoShow(false);
      onUpdate();
      toast.success("Solicitação do Pedido de Prorrogação excluído com sucesso.");
    }

    if (deleteItemErrors) {
      toast.error(deleteItemErrors);
    }

    setShowExcluirConfirm({ show: false });
  }, [deleteItemData, deleteItemErrors, onUpdate, setSolicitarProrrogacaoShow, setShowExcluirConfirm, setValues]);
  // Fim exclusão

  const ExcluirModal = (
    <EfisModal
      show={showExcluirConfirm.show}
      body={showExcluirConfirm.body}
      loadingConfirmationAction={deleteItemIsLoading}
      closeHandler={() => setShowExcluirConfirm({ show: false })}
      confirmationHandler={() => {
        const params = { sqPedidoProrrogacao: showExcluirConfirm.context };
        deleteItemRequest(apiRoutes.fiscalizacao.prorrogacaoos.excluirProrrogacaoOs, params);
      }}
    />
  );

  return {
    ExcluirModal,
    setShowExcluirConfirm,
  };
};

export default useExcluirProrrogacaoModal;
